import React, { useMemo } from 'react';
import { Button, Result as AntResult, Typography } from 'antd';
import { ResultStatusType } from 'antd/es/result';
import {
  isRouteErrorResponse, useLocation, useNavigate, useRouteError,
} from 'react-router-dom';
import styles from './index.module.scss';

const { wrapper } = styles;

function ErrorPage() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const error = useRouteError();
  const getSubtitle = (type: ResultStatusType) => {
    switch (type) {
      case '404':
        return <Typography.Text type="secondary">This page was not found</Typography.Text>;
      default:
        return <Typography.Text type="secondary">Sorry, there was an error processing this route.</Typography.Text>;
    }
  };

  const Result = useMemo(() => {
    if (isRouteErrorResponse(error) || error instanceof Response) {
      return (
        <AntResult
          status={error.status.toString() as ResultStatusType}
          title={<Typography.Text strong>{error.status.toString()}</Typography.Text>}
          subTitle={error.statusText || getSubtitle(error.status.toString() as ResultStatusType)}
          extra={(
            <Button onClick={() => navigate('/map')} type="primary">
              <Typography.Text>Back to home</Typography.Text>
            </Button>
          )}
        />
      );
    }

    if (error instanceof TypeError && process.env.NODE_ENV === 'development') {
      const e: TypeError = error as TypeError;
      return (
        <AntResult
          status="error"
          title={<Typography.Text strong type="danger">Oops! Something has gone wrong...</Typography.Text>}
        >
          <Typography.Title level={2}>
            {`${e.name}: ${e.message}`}
          </Typography.Title>
          <Typography.Title level={3}>
            {e.cause as string }
          </Typography.Title>
          <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>
            {e.stack}
          </Typography.Paragraph>
        </AntResult>
      );
    }

    return (
      <div className={wrapper}>
        <AntResult
          status="error"
          title={<Typography.Text strong type="danger">Oops! Something has gone wrong...</Typography.Text>}
          extra={(
            <Button onClick={() => navigate(`/app/map${search}`)} type="primary">
              <Typography.Text>Back to home</Typography.Text>
            </Button>
          )}
        />
      </div>
    );
  }, [error, navigate, search]);

  return (
    <div className={wrapper}>
      {Result}
    </div>
  );
}
export default ErrorPage;
